<template>
  <v-container class="fullscreen" @keydown.enter="login">
    <v-card class="default-background fullheight-card" flat>
      <v-row justify="space-around" align="center" class="full-height">
        <v-col cols="10" xs="10" sm="6" md="4" lg="2">
          <v-form @submit.prevent="logUser()">
            <v-card>
              <v-card-title class="mb-1">
                <v-spacer></v-spacer>
                <WifipassIcon />
                <div class="black--text ml-1">Wifipass</div>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mb-3">
                <v-alert v-if="loginError" type="error">
                  Les identifiants saisis ne sont pas valides.
                </v-alert>
                <v-text-field
                  label="Nom d'utilisateur"
                  v-model="userName"
                  prepend-icon="mdi-account-circle"
                />
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  label="Mot de passe"
                  v-model="password"
                  prepend-icon="mdi-lock"
                />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="black"
                  text
                  block
                  type="submit"
                  :loading="loginLoading"
                >
                  Se connecter
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import { useLogin } from "../composables/login.js";
import { toRefs, ref } from "@vue/composition-api";
import WifipassIcon from "@/components/Icones/wifipass-logo.vue";
import router from "@/router";

export default {
  components: {
    WifipassIcon,
  },
  setup() {
    const { data, login } = useLogin();
    const showPassword = ref(false);
    const loginLoading = ref(false);

    data.userName = localStorage.getItem("userName") ?? "";

    const logUser = async function () {
      loginLoading.value = true;
      await login();
      router.push({
        path:
          localStorage.getItem("lastVisitedUrl") != null
            ? localStorage.getItem("lastVisitedUrl")
            : "/",
      });
      loginLoading.value = false;
    };

    return {
      ...toRefs(data),
      login,
      showPassword,
      logUser,
      loginLoading,
    };
  },
};
</script>
